// Reaching a quoted message that is older than the loaded ones: load earlier
// pages one at a time until it is rendered.
//   findElement()  -> the message element, or null while it is not rendered
//   canLoad()      -> false once there is nothing more to load (or the chat changed)
//   loadPrevious() -> loads one earlier page and waits for the render; false on failure
// Resolves to the element, or null when it was not found within `pages` pages.
export const loadUntilFound = async ({
  findElement,
  canLoad,
  loadPrevious,
  pages,
}) => {
  const element = findElement();
  if (element) return element;
  if (pages <= 0 || !canLoad()) return null;
  if (!(await loadPrevious())) return null;
  return loadUntilFound({ findElement, canLoad, loadPrevious, pages: pages - 1 });
};
